import {
  AbsenceClient,
  AbsenceTypeClient,
  AccountClient,
  AdminClient,
  AppUserBillableTargetHistoryClient,
  AppUserClient,
  AppUserHistoryClient,
  AppUserInternalCostHistoryClient,
  AppUserRightClient,
  AppUserVacationHistoryClient,
  InvoiceClient,
  ListClient,
  ListSharedClient,
  LookupClient,
  NewsClient,
  OutgoingInvoiceClient,
  PaymentClient,
  ProjectClient,
  ProjectFixedPriceReportClient,
  ProjectStaffClient,
  ProjectTaskClient,
  PublicHolidayClient,
  PublicHolidayGroupClient,
  RateRuleClient,
  ReportContollerClient,
  RoleClient,
  StopwatchClient,
  SupportClient,
  TagClient,
  TeamOverviewClient,
  TimeAccountClient,
  TimeAdjustmentClient,
  TimeEntryClient,
  TimeEntryDayApprovalClient,
  TimeEntryExtraFieldMetadataClient,
  TransferAccountClient,
} from '@/services/api/nswag/stapiclient_generated';
import { AuthenticationClient, CustomerClient, ImpersonateClient } from '@/services/api/nswag/stapiclient_generated';
import axios from 'axios';

// @ts-ignore
const apiBasePath = process.env.VUE_APP_APIURL.replace(/\/+$/, '');

export const stAuthenticationApi = new AuthenticationClient(apiBasePath, axios);
export const stCustomerApi = new CustomerClient(apiBasePath, axios);
export const stImpersonationApi = new ImpersonateClient(apiBasePath, axios);

export const stProjectApi = new ProjectClient(apiBasePath, axios);
export const stProjectTaskApi = new ProjectTaskClient(apiBasePath, axios);
export const stRateRuleApi = new RateRuleClient(apiBasePath, axios);
export const stAppUserApi = new AppUserClient(apiBasePath, axios);
export const stAppUserHistoryApi = new AppUserHistoryClient(apiBasePath, axios);
export const stAppUserVacationHistoryApi = new AppUserVacationHistoryClient(apiBasePath, axios);
export const stAppUserInternalCostHistoryApi = new AppUserInternalCostHistoryClient(apiBasePath, axios);
export const stAppUserBillableTargetHistoryApi = new AppUserBillableTargetHistoryClient(apiBasePath, axios);
export const stAccountApi = new AccountClient(apiBasePath, axios);
export const stTimeEntryApi = new TimeEntryClient(apiBasePath, axios);
export const stTagApi = new TagClient(apiBasePath, axios);
export const stStopwatchApi = new StopwatchClient(apiBasePath, axios);
export const stLookupApi = new LookupClient(apiBasePath, axios);
export const stPublicHolidayGroupApi = new PublicHolidayGroupClient(apiBasePath, axios);
export const stPublicHolidayApi = new PublicHolidayClient(apiBasePath, axios);
export const stAbsenceApi = new AbsenceClient(apiBasePath, axios);
export const appUserRightApi = new AppUserRightClient(apiBasePath, axios);
export const roleApi = new RoleClient(apiBasePath, axios);
export const projectStaffApi = new ProjectStaffClient(apiBasePath, axios);
export const stListApi = new ListClient(apiBasePath, axios);
export const stListSharedApi = new ListSharedClient(apiBasePath, axios);
export const stReportApi = new ReportContollerClient(apiBasePath, axios);
export const stPaymentApi = new PaymentClient(apiBasePath, axios);
export const outgoingInvoiceApi = new OutgoingInvoiceClient(apiBasePath, axios);
export const timeEntryExtraFieldMetadataClient = new TimeEntryExtraFieldMetadataClient(apiBasePath, axios);
export const supportApi = new SupportClient(apiBasePath, axios);
export const stAdminApi = new AdminClient(apiBasePath, axios);
export const stInvoiceApi = new InvoiceClient(apiBasePath, axios);
export const stTransferAccountApi = new TransferAccountClient(apiBasePath, axios);
export const stNewsApi = new NewsClient(apiBasePath, axios);
export const stTimeAdjustmentApi = new TimeAdjustmentClient(apiBasePath, axios);
export const stTimeAccountApi = new TimeAccountClient(apiBasePath, axios);
export const stTeamOverviewApi = new TeamOverviewClient(apiBasePath, axios);
export const stTimeEntryDayApprovalApi = new TimeEntryDayApprovalClient(apiBasePath, axios);
export const stAbsenceTypeApi = new AbsenceTypeClient(apiBasePath, axios);
export const stProjectFixedPriceReportApi = new ProjectFixedPriceReportClient(apiBasePath, axios);
